import { Component } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { LoaderService } from '../../core/services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { boldIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'app-whatsappfiles',
  templateUrl: './whatsappfiles.component.html',
  styleUrl: './whatsappfiles.component.scss',
  standalone: false,
})
export class WhatsappfilesComponent {
  queryParams: any = {};
  isDowload: boolean = false;
  constructor(
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const fullUrl = this.router.url; // e.g. /files/RP250717113844371039/bills
    const pathSegments = fullUrl.split('/'); // ['', 'files', 'RP250717113844371039', 'bills']

    if (pathSegments.length < 4) {
      console.warn('Unexpected URL structure');
      return;
    }

    const shortcode = pathSegments[2]; // RP250717113844371039
    const type = pathSegments[3]; // bills

    console.log('Shortcode:', shortcode);
    console.log('Type from path:', type);

    // Normalize if needed (e.g., convert "bills" to "bill")
    const normalizedType = type.toLowerCase().replace(/s$/, '');
    this.isDowload = false;
    switch (normalizedType) {
      case 'faq':
        console.log('Loading FAQ...');
        this.sharedService.getWhatsappFaqFiles(shortcode).subscribe({
          next: (fileBlob: Blob) => {
            // Try to infer the file name from the response headers or define manually
            const fileType = fileBlob.type;
            let fileExtension = '';

            // Optional: Infer extension based on MIME type
            if (fileType.includes('pdf')) fileExtension = 'pdf';
            else if (fileType.includes('msword')) fileExtension = 'doc';
            else if (fileType.includes('wordprocessingml'))
              fileExtension = 'docx';
            else if (fileType.includes('image/png')) fileExtension = 'png';
            else if (fileType.includes('image/jpeg')) fileExtension = 'jpg';

            const fileName = `Whatsapp-FAQ.${fileExtension || 'file'}`;
            this.isDowload = true;
            const url = window.URL.createObjectURL(fileBlob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();

            // Cleanup
            window.URL.revokeObjectURL(url);
          },

          error: (err) => console.error('Download failed:', err),
        });

        /* this.sharedService.getWhatsappFaqFiles(shortcode).subscribe({
          next: (res) => {
            this.sharedService.downloadFile(res.data, 'faq-file');
            if (res.statusCode == 200) {
             // this.sharedService.downloadFile(res.data, 'faq-file');
               window.open(res.data);
            }
            console.log(res);
          },

          error: (err) => console.error(err),
        }); */
        break;

      case 'invoice':
        console.log('Loading Invoice...');
        this.sharedService.getWhatsappInvoiceFaqFiles(shortcode).subscribe({
          next: (res: Blob) => {
            const contentType = res.type || 'application/octet-stream';
            const extension = this.getExtensionFromMimeType(contentType);
            const filename = `Invoice-file.${extension}`;
            this.isDowload = true;
            this.sharedService.downloadFile(res, filename);
          },
          error: (err) => console.error(err),
        });
        break;

      case 'bill':
        console.log('Loading Bill...');
        this.sharedService.getWhatsappBillsFaqFiles(shortcode).subscribe({
          next: (res: Blob) => {
            const contentType = res.type || 'application/octet-stream';
            const extension = this.getExtensionFromMimeType(contentType);
            const filename = `bill-file.${extension}`;
            this.isDowload = true;
            this.sharedService.downloadFile(res, filename);
          },
          error: (err) => console.error(err),
        });
        break;

      default:
        console.warn('Unknown type in URL:', type);
        break;
    }
  }
  getExtensionFromMimeType(mimeType: string): string {
    switch (mimeType) {
      case 'application/pdf':
        return 'pdf';
      case 'application/msword':
        return 'doc';
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return 'docx';
      case 'image/jpeg':
        return 'jpg';
      case 'image/png':
        return 'png';
      case 'image/webp':
        return 'webp';
      default:
        return 'bin'; // fallback for unknown types
    }
  }
}
